var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0 mb-n1 px-2 py-3 transparent-border",attrs:{"color":"alert shadow-alert","tile":""}},[_c('div',{staticClass:"event-alert d-flex flex-row px-4"},[_c('div',[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("$iconBell")])],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }